import { Typography } from "@mui/material";
import classNames from "classnames";

import { FilterMatch } from "../../Sidebar/filterResult";
import { HighlightedText } from "../../Sidebar/HighlightedText";

import styles from "./TopicLabel.module.css";

export interface TopicLabelProps {
  className?: classNames.Argument;
  dataType: string;
  label: string;
  match?: FilterMatch;
}

export function TopicLabel(props: TopicLabelProps) {
  const { className, dataType, label, match } = props;

  return (
    <div className={classNames(className, styles.labelContainer)}>
      <p
        className={classNames(
          "ph-no-capture",
          styles.hideOverflow,
          styles.label,
        )}
      >
        <HighlightedText text={label} match={match} />
      </p>
      <Typography
        className={classNames(
          styles.dataTypeLabel,
          styles.hideOverflow,
          styles.label,
        )}
        color="text.secondary"
      >
        {dataType}
      </Typography>
    </div>
  );
}
